<template>
  <v-app id="temporary-disable">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <el-card class="box-card" v-if="errors.length > 0">
              <h2 class="title text-center">
                บัญชีของคุณไม่สามารถใช้งานได้ชั่วคราว กรุณาติดต่อเจ้าหน้าที่
              </h2>
              <template v-if="errors[0].type == 'expired'">
                <div class="mt-3 text-center">
                  <img
                    src="../assets/img/logo-full-text.png"
                    style="width:28%;"
                  />
                </div>
              </template>
            </el-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import Service from "../services";

export default {
  props: {},
  data: () => ({
    errors: [],
    invoiceUrl: null,
  }),
  created() {
    Service.User.me().then((res) => {
      this.errors = res.data.errors;
      this.invoiceUrl = res.data.invoice_url;
    });
  },
  methods: {},
};
</script>
